import { Box, Stack, Switch } from "@mui/material";
import _ from "lodash";
import { makeStyles, styled } from "@mui/styles";
import { useDispatch } from "react-redux";
import React, { useEffect, useState } from "react";
import VSNTypography from "../../../shared/VSNTypography";
import VSNTextField from "../../../shared/VSNTextField";
import { SET_API_DATA } from "../../../redux/constants";

const AntSwitch = styled(Switch)(({ theme }) => ({
  "&.MuiSwitch-root": {
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 15,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(9px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "var(--white)",
        "& + .MuiSwitch-track": {
          opacity: 1,
          background: "var(--Tertiary)",
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.3,
          background: "var(--Tertiary)",
        },
      },
      "& + .MuiSwitch-track": {
        background: "#00000040",
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: "all 0.4s ease-in-out",
    },
    "& .MuiSwitch-track": {
      borderRadius: 10,
      opacity: 1,
      boxSizing: "border-box",
    },
  },
}));

const useStyles = makeStyles((theme) => ({
  selectMain: {
    gap: 24,
    marginTop: 8,
    flexWrap: "wrap",
    "& .MuiStack-root": {
      height: 67,
      maxWidth: 409,
      width: "100%",
      backgroundColor: "var(--white)",
      border: "1px solid #EAEDF0",
      borderRadius: 5,
      color: "var(--gray)",
      cursor: "pointer",
      transition: "all 0.3s ease-in-out",
      padding: 13,
      boxShadow: "0px 9px 20px 0px #968FB01A",
      "&:hover": {
        color: "var(--primary)",
        borderColor: "var(--primary)",
      },
      "&.active": {
        borderColor: "var(--primary)",
        color: "var(--primary)",
        boxShadow: "0px 9px 20px 0px #968FB01A",
      },
    },
    "& .MuiInputBase-root": {
      "& .MuiInputBase-input": {
        border: "1px solid #EAEDF0",
        borderRadius: "4px",
        boxShadow: " 0px 9px 20px 0px #968FB01A",
        "&.MuiOutlinedInput-input": {
          minHeight: "11px",
          padding: "16px 32px",
          color: "var(--gray)",
          fontSize: 18,
          lineHeight: "20.83px",
          fontWeight: 500,
        },
      },
    },
    "& fieldset": {
      borderColor: "#EAEDF0",
    },
  },
  information: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    maxWidth: 1210,
    width: "100%",
    margin: "0 auto",
    padding: "0 15px",
    marginBottom: 40,
    "& h4": {
      fontSize: 22,
      lineHeight: "38.21px",
      fontWeight: 600,
      color: "var(--darkGray)",
      textAlign: "center",
      marginBottom: "8px",
      [theme.breakpoints.down("md")]: {
        lineHeight: "31px",
        marginBottom: 10,
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: 18,
        padding: [[0]],
        marginBottom: 10,
      },
    },
  },
}));

const ToggleComponent = ({
  question,
  onChange,
  value,
  onChangeMultiChoice,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [textFieldValue, setTextFieldValue] = useState(
    value?.value?.result ?? ""
  );

  useEffect(() => {
    const newToggleValue = _.isEmpty(textFieldValue);
    if (textFieldValue) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          toggleTextFieldValue: newToggleValue,
        },
      });
    }
    if (value?.switch && !textFieldValue) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          toggleTextFieldValue: true,
        },
      });
    }
  }, [value, textFieldValue]);

  const handleToggleChange = (e) => {
    const newSwitchValue = e.target.checked;
    dispatch({
      type: SET_API_DATA,
      payload: {
        toggleTextFieldValue: newSwitchValue,
      },
    });
    setTextFieldValue("");
    onChange({ result: "" }, { ...question, switch: newSwitchValue });
  };

  const handleTextFieldChange = (e) => {
    const inputValue = e.target.value;
    setTextFieldValue(inputValue);
    onChange({ result: inputValue }, value);
  };

  useEffect(
    () => () =>
      dispatch({
        type: SET_API_DATA,
        payload: {
          toggleTextFieldValue: false,
        },
      }),
    []
  );

  return (
    <Box className={classes.information}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        mb={1}
        spacing={2}
      >
        <VSNTypography
          variant="h4"
          component="h4"
          sx={{ "&.MuiTypography-h4": { mb: 0 } }}
        >
          {`${question?.order}. ${question?.phrase}`}
        </VSNTypography>
        <AntSwitch checked={value?.switch} onChange={handleToggleChange} />
      </Stack>
      <Stack
        direction="row"
        justifyContent="center"
        className={`${classes.selectMain}`}
      >
        {value?.switch && (
          <VSNTextField
            variant="outlined"
            id={question.id}
            fullWidth
            name={question?.phrase}
            value={textFieldValue}
            onChange={handleTextFieldChange}
            type="text"
          />
        )}
      </Stack>
    </Box>
  );
};

export default ToggleComponent;
